import { Image } from "@mantine/core";

export function LogoComponent() {
  return <Image width={200} src="/assets/images/logo.svg" alt="logo" />;
}
